<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <form v-on:submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mt20">{{'Name'|translate}}</label>
              <input
                v-model="item.name"
                required
                ref="name"
                :placeholder="'Name'|translate"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mt20">{{'Email'|translate}}</label>
              <input
                v-model="item.email"
                :disabled="item.id"
                type="email"
                required
                ref="email"
                :placeholder="'Email'|translate"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mt20">{{'Address'|translate}}</label>
              <input
                v-model="item.address"
                ref="address"
                :placeholder="'Address'|translate"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mt20">{{'Phone'|translate}}</label>
              <input
                v-model="item.phone"
                :disabled="item.id"
                ref="phone"
                :placeholder="'Phone'|translate"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" v-if="!item.id">
              <label class="mt20">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <p>{{'10 digit begin with 0'|translate}}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="mt20">{{'Password'|translate}}</label>
              <input
                v-model="item.password"
                ref="password"
                :placeholder="'Password'|translate"
                type="password"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mt20">{{'Repeat Password'|translate}}</label>
              <input
                v-model="item.repeat_password"
                ref="repeat_password"
                :placeholder="'Repeat Password'|translate"
                type="password"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <p
          v-if="item.id"
          class="label label-default"
        >{{'Only input password if you want to change password'|translate}}</p>
        <p>
          <button class="btn btn-info mt20" type="submit" :disabled="working">
            <i v-if="working" class="fas fa-spinner fa-spin"></i>
            {{getOKText}}
          </button>
        </p>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "@/components/elements/Loading";
import Config from "@/helpers/config";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormSubUser",
  components: {
    mymodal,
    Loading
  },
  props: ["pass_data"],
  computed: {
    getTitleText() {
      if (this.item.id) {
        return this.$t("Update user");
      } else {
        return this.$t("Add user");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    let dateFormat = "DD/MM/YYYY";
    return {
      working: false,
      dateFormat: dateFormat,
      item: {},
      country_code: Config.country_code
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    defaultValue() {
      return {
        name: "",
        phone: "",
        address: "",
        password: "",
        repeat_password: ""
      };
    },
    open() {
      this.$refs.theModal.open();
      if (this.pass_data) {
        this.item = JSON.parse(JSON.stringify(this.pass_data));
        this.item.password = "";
        this.item.repeat_password = "";
      } else {
        this.item = this.defaultValue();
      }

      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    submitForm() {
      let data = JSON.parse(JSON.stringify(this.item));
      data.start_date = this.$moment(data.start_date, this.dateFormat).toDate();
      data.start_time = Math.floor(data.start_date.getTime() / 1000);
      data.block_id = this.block_id;
      if (!Utils.validPhone(data.phone)) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Your phone is not valid")
        );
      }

      let request;
      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.request(this, true, "subuser").post(
          `/manageSubUser/?is_update=true`,
          data
        );
      } else {
        request = Utils.request(this, true, "subuser").post(
          `/manageSubUser/`,
          data
        );
      }

      request
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SubUser/FormSubUser.vue